(function(){
  var wrapper = document.getElementById('promo-countdown');
  if (!wrapper) return;
  var timerEl = document.getElementById('promo-countdown-timer');
  var endDate = new Date(wrapper.dataset.endDate);

  function pad(n){ return n < 10 ? '0' + n : n; }

  function update(){
    var now  = new Date();
    var diff = endDate - now;
    if (diff <= 0) {
      timerEl.textContent = '00h 00 min 00 s';
      return clearInterval(timer);
    }
    var totalHours = Math.floor(diff / 3600000);
    var mins  = Math.floor(diff / 60000) % 60;
    var secs  = Math.floor(diff / 1000)  % 60;

    timerEl.textContent = 
      totalHours + ' godz ' +
      pad(mins)      + ' min ' +
      pad(secs)      + ' sek';
  }

  update();
  var timer = setInterval(update, 1000);
})();